<template>
	<a href="#" class="menu-btn" @click.prevent="toggleMenu">
		<div class="menu-btn__wrap">
			<div class="menu-btn__line menu-btn__line-1"></div>
			<div class="menu-btn__line menu-btn__line-2"></div>
		</div>
	</a>
</template>

<script>
import Vue from "vue";
export default Vue.extend({
	name: "MobMenuBtn",
	data() {
		return {
			isBtnPressed: false
		};
	},
	components: {},
	methods: {
		toggleMenu(el) {
			const target = el.target.parentNode;
			if (target.classList.contains("active")) {
				target.classList.remove("active");
				this.isBtnPressed = false;
			} else {
				target.classList.add("active");
				this.isBtnPressed = true;
			}
			this.$emit("btnPressed", this.isBtnPressed);
		}
	}
});
</script>

<style lang="scss" scoped>
.menu-btn {
	border: 1px solid $border-color;
	background-color: $table-light-bg;
	border-radius: 5px;
	display: inline-block;
	position: relative;

	$menu-height: 21px;
	$menu-width: 21px;

	$space-offset: 3.6px;
	$line-height: 3.5px;
	$line-width: 13px;

	height: $menu-height;
	width: $menu-width;

	&__wrap {
		height: 100%;
		width: 100%;
	}

	&__line {
		transition: opacity 100ms, top 100ms ease, transform 100ms ease;

		width: $line-width;
		height: $line-height;
		left: #{$menu-width / 2 - $line-width / 2};
		position: absolute;

		backface-visibility: hidden;
		background-color: black;
		pointer-events: none;
	}

	&__line-1 {
		top: ($menu-height / 2 - $line-height / 2 - $space-offset);
	}

	&__line-2 {
		top: ($menu-height / 2 - $line-height / 2 + $space-offset);
	}

	&.active {
		.menu-btn__line-1 {
			transform: rotate(45deg);
			top: ($menu-height / 2 - $line-height / 2);
		}

		.menu-btn__line-2 {
			transform: rotate(-45deg);
			top: ($menu-height / 2 - $line-height / 2);
		}
	}
}
</style>